import { render, staticRenderFns } from "./CardPanel.vue?vue&type=template&id=7b15510e&scoped=true"
import script from "./CardPanel.vue?vue&type=script&lang=js"
export * from "./CardPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b15510e",
  null
  
)

export default component.exports